/// <reference path="../_all.ts" />

module search {
  'use strict';

  var escape = new RegExp('[\\-\\[\\]\\/\\{\\}\\(\\)\\*\\+\\?\\.\\\\\^\\$\\|]', 'g');

  export function HighlightKeywordsFilter() {

     return function(input:string, words: string[]) {
       //http://stackoverflow.com/a/31676948/142679

       if (!words || words.length == 0 || !input) return input;

       var wordsEscaped : string [] = new Array();
       words.sort((a: string, b: string) => b.length - a.length).forEach( (value:string, index: number, array : string[]) : void => {
         wordsEscaped.push(value.replace(escape, "\\$&"));
       });

       var allTermsRegexStr : string = wordsEscaped.join('|');
       var regex = new RegExp('(' + allTermsRegexStr + ')', 'ig');
       return input.replace(regex, '<strong>$&</strong>');
     }
  }


}